import React, { useCallback, Ref } from 'react';
import { Hideable } from '@regular_ui/lib/components/hideable';

import * as S from './styles';

type Props = {
  id: string;
  name: string;
  logo?: string;
  isOpen: boolean;
  onClickCategoryButton: (id: string) => void;
  buttonRef?: Ref<HTMLButtonElement>;
};

const TopLevelCategoryItem = ({
  id,
  name,
  logo,
  isOpen,
  onClickCategoryButton,
  buttonRef,
}: Props) => {
  const onClick = useCallback(() => onClickCategoryButton(id), [
    id,
    onClickCategoryButton,
  ]);

  return (
    <S.TopLevelItem>
      <S.TopLevelButton
        onClick={onClick}
        isOpen={isOpen}
        ref={buttonRef}
        aria-expanded={isOpen}
        aria-haspopup
        data-test="MegaMenuButton"
        data-test-id={id}
      >
        <S.TopLevelIcon src={logo} alt="" />
        <S.TopLevelCategoryName>{name}</S.TopLevelCategoryName>
        <Hideable visible={isOpen}>
          <S.TopLevelArrow />
        </Hideable>
      </S.TopLevelButton>
    </S.TopLevelItem>
  );
};

export default TopLevelCategoryItem;
